import React, { useState } from 'react';
import { Button, Grid, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import CommonDialog from 'components/commonDialog/CommonDialog';
import CommonFilter from 'components/commonFilter/CommonFilter';
import SearchBar from 'components/commonSearch/SearchBar';

function DriverBreadCrumb(props) {
  const [open, setOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'));
  const isMobileOrTablet = isMobile || isTablet;

  const handleClose = () => setOpen(false);
  const addVendor = () => setOpen(true);

  const onDialog = (data, code) => {
    props?.onSubmittBtn(data, code);
    setOpen(false);
  };

  return (
    <div>
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        className="margin10"
      >
        {/* Search, Filter, and Driver Button Row */}
        <Grid
          item
          container
          xs={12}
          md={12}
          spacing={isMobileOrTablet ? 1 : 2}
          direction="row"
          justifyContent={isMobileOrTablet ? 'flex-start' : 'flex-end'}
          alignItems="center"
          wrap={isMobileOrTablet ? 'nowrap' : 'wrap'}
          sx={{
            flexWrap: isMobileOrTablet ? 'nowrap' : 'wrap',
            overflowX: isMobileOrTablet ? 'auto' : 'visible',
            gap: isMobileOrTablet ? '8px' : '16px',
            paddingRight: isMobileOrTablet ? 0 : '8px',
          }}
        >
          {/* SearchBar */}
          <Grid
            item
            sx={{
              flex: isMobile ? '0 0 60%' : '0 0 auto', // 60% only in mobile
            }}
          >
            <SearchBar onSearch={props.onSearch} />
          </Grid>

          {/* Filter */}
          <Grid item>
            <CommonFilter
              defaultStatus={props?.defaultStatus}
              filterdata={props?.filterdata}
              onFilterChange={props?.onFilterChange}
              onRestFilter={props?.onRestFilter}
            />
          </Grid>

          {/* Driver + Button */}
          {props?.companyType !== 'adminCompany' && props?.addButton && (
            <Grid
              item
              sx={{
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <Button
                onClick={addVendor}
                className="btnSubvendor"
                sx={{
                  whiteSpace: 'nowrap',
                  flexShrink: 0,
                  marginLeft: 0, // ❌ remove extra margin
                  paddingLeft: '16px',
                  paddingRight: '16px',
                  minWidth: 'auto',
                }}
              >
                Driver +
              </Button>
            </Grid>
          )}
        </Grid>
      </Grid>

      {/* CommonDialog */}
      {open && (
        <CommonDialog
          open={open}
          handleClose={handleClose}
          formData={props?.formData}
          button="dialogButton"
          onSubmittBtn={onDialog}
          type="Driver"
          selectType="Create"
          defaultValues={props?.defaultValues}
        />
      )}
    </div>
  );
}

export default DriverBreadCrumb;
